/**
 * 職種紹介テンプレート - フロント側のホバー Lottie 再生
 */
import lottie, { type AnimationItem } from 'lottie-web';

const init = (): void => {
	const items = document.querySelectorAll<HTMLElement>(
		'.wp-block-best-anniversary-blocks-job-template__item'
	);

	items.forEach((item) => {
		const target = item.querySelector<HTMLElement>(
			'.wp-block-best-anniversary-blocks-job-template__more'
		);
		if (!target) {
			return;
		}
		const path = target.dataset.lottie;
		if (!path) {
			return;
		}

		const animation: AnimationItem = lottie.loadAnimation({
			container: target,
			renderer: 'svg',
			loop: false,
			autoplay: false,
			path,
			rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
		});

		item.addEventListener('mouseenter', () => {
			animation.goToAndPlay(0, true);
		});
		item.addEventListener('mouseleave', () => {
			animation.goToAndStop(0, true);
		});
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
